export default {"src":"/_next/static/media/car_traffic_2.4a7c1c04.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};